export enum MeasurementKey {
	BMI = 'bmi_calc',
}
